import { render, staticRenderFns } from "./OfferTypeTag.vue?vue&type=template&id=054c94ae&scoped=true&"
import script from "./OfferTypeTag.vue?vue&type=script&lang=ts&"
export * from "./OfferTypeTag.vue?vue&type=script&lang=ts&"
import style0 from "./OfferTypeTag.vue?vue&type=style&index=0&id=054c94ae&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054c94ae",
  null
  
)

export default component.exports